/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BugIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACA0lEQVR4nM1VO2sVURBewUdrEQutfGCwUAs7tbiKYC7ec+abvbo7sxEJsbi+LoKVTcogooX4C4K1RSD6D4KC0cLOf6FG8FEZmb27l3vj2bsbDejAB3vOmZmPeexMFP1LIUrPe9YvBH1PrNeL6x1Eem9wJ+uAnPtjAjP20G/EulHga4Hh2XHW+qsoWq3WTs/yfMRpDruzt2g7xENeBghWov9SmOUIIGfKc7vd3mMFJuiLdpLsM9i33SVJsrvUc5ALLk5P1RJ4lnfE+pNivUOkBzzL22FqKJ3PUZ6ha6aT65oN5EMtAZDdyJVzyPp43vWZYbweuU6hP2zl2ij6m4tKA/woEHq7GTUV182OVTjZqILZNCYg1odbJSDIg+YEkNdbJfCsryY69SzOQ+4T60JVnj3kKbE8mVCfx3n0pBRIy3jHBBHr3aIlJ0cD/fwbAZBdMnYPfUSQ70FjSuc961xFDcxmwbIApDN1NVgNE+gVh+xyBcFq4yJ76GLICZDOOJaLFWlZbEzQ6WZHg0666VnH2enQG7NMN4+A5VaQwOtJYPZEuE2l38i5g1wrZ4tn+TROkBwC5OCmWfSx1Lc5VktALMuF834cX92fT8xyHLhsyjDyX7wxHYfs9mCa6lotATC3txOnx8tzr9fbVYzoJVv4+dJnXbJ2HV2ZtkM63dnDjdK0nfILRFj12o9ufmYAAAAASUVORK5CYII=)
 */
export const BugIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.54 3.28a3 3 0 0 0-.37.74c-.19.52.28.98.83.98h4c.55 0 1.02-.46.83-.98a2.96 2.96 0 0 0-.37-.74c.23-.16.56-.28.99-.28a1 1 0 1 0 0-2c-1 0-2.01.4-2.68 1.1a3 3 0 0 0-1.54 0A3.76 3.76 0 0 0 8.55 1a1 1 0 0 0 0 2c.43 0 .76.12 1 .28ZM18.01 18.85c-.04.1-.03.22.05.3l1.51 1.5a1 1 0 0 1-1.41 1.42l-1.18-1.18a.26.26 0 0 0-.37 0 6.7 6.7 0 0 1-2.8 1.82c-.42.14-.83-.2-.86-.64l-.42-8.57a.53.53 0 0 0-1.05 0l-.43 8.57c-.03.45-.44.78-.87.64A6.7 6.7 0 0 1 7.4 20.9a.26.26 0 0 0-.37-.01l-1.18 1.18a1 1 0 0 1-1.41-1.41l1.51-1.51c.08-.08.1-.2.05-.3-.47-.94-.78-2-.92-3.12a.25.25 0 0 0-.25-.23H3a1 1 0 1 1 0-2h1.82c.13 0 .24-.1.25-.23.14-1.13.45-2.18.92-3.12a.25.25 0 0 0-.05-.3l-1.51-1.5a1 1 0 1 1 1.41-1.42L7.02 8.1c.1.1.27.1.37 0a6.66 6.66 0 0 1 2.95-1.87c.38-.11.75.14.85.52l.57 2.27c.06.25.42.25.48 0l.57-2.27c.1-.38.47-.63.85-.52 1.1.33 2.11.98 2.95 1.86.1.1.26.11.37.01l1.18-1.18a1 1 0 1 1 1.41 1.41l-1.51 1.51c-.08.08-.1.2-.05.3.47.94.78 2 .92 3.12.01.13.12.23.25.23H21a1 1 0 1 1 0 2h-1.82c-.13 0-.24.1-.25.23a9.68 9.68 0 0 1-.92 3.12Z"
        className={colorClass}
      />
    </svg>
  );
};
